const EMAIL_ENDPOINT = import.meta.env.PROD
  ? '/send-email.php'
  : '/api/send-email';

export async function sendFormEmail(formData, isEarlyAccess = false) {
  const response = await fetch(EMAIL_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ formData, isEarlyAccess }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to send email');
  }

  return response.json();
}
